import {
  BubbleText,
  Text,
  useDsTheme,
  Warning,
} from "@totalenergiescode/mobility-business-rev-design-system";
import type { TFunction } from "i18next";

import {
  StyledErrorBadgeWrapper,
  StyledErrorBanner,
  StyledErrorContent,
  StyledErrorIconWrapper,
  StyledErrorMessage,
} from "./styles";

export const CreationErrorBanner = ({
  errorMessage,
  tFormData,
}: {
  errorMessage: string;
  tFormData: TFunction<"formData">;
}) => {
  const theme = useDsTheme();
  const errorColor = theme.palette.danger.danger[500] || "";

  return (
    <StyledErrorBanner data-testid='formdata__creation-template-error-banner'>
      <StyledErrorIconWrapper>
        <Warning width={24} height={24} color={errorColor} />
      </StyledErrorIconWrapper>
      <StyledErrorContent>
        <Text variant='title1'>
          {tFormData("formData.creationTemplate.errors.title")}
        </Text>
        <StyledErrorMessage>{errorMessage}</StyledErrorMessage>
        <StyledErrorBadgeWrapper>
          <BubbleText
            variant='red'
            text={tFormData("formData.creationTemplate.errors.code")}
          />
        </StyledErrorBadgeWrapper>
      </StyledErrorContent>
    </StyledErrorBanner>
  );
};
